var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilters = function SvgFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.375 17.375h5.25v1.25h-5.25v-1.25ZM1.375 5.375h5.25v1.25h-5.25v-1.25ZM13.375 5.375h9.25v1.25h-9.25v-1.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.375 2c0-.345.28-.625.625-.625h4c.345 0 .625.28.625.625v8c0 .345-.28.625-.625.625H6A.625.625 0 0 1 5.375 10V2Zm1.25.625v6.75h2.75v-6.75h-2.75ZM13.375 14c0-.345.28-.625.625-.625h4c.345 0 .625.28.625.625v8c0 .345-.28.625-.625.625h-4a.625.625 0 0 1-.625-.625v-8Zm1.25.625v6.75h2.75v-6.75h-2.75ZM1.375 17.375h9.25v1.25h-9.25v-1.25Z",
    fill: "currentColor"
  })));
};
export default SvgFilters;